/* istanbul ignore file */
import { RemediationTaskApprovalStatus } from "stan-client";

export const isApproved = (status: RemediationTaskApprovalStatus): boolean =>
  status === "approved" || status === "auto_approved";
